// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-popover ion-list {
  padding: 5px 0;
  margin: 0;
  border-radius: 10px;
  border: 2px var(--ion-color-secondary) solid;
  width: 200px;
  align-self: end;
}
.menu-popover ion-icon {
  font-size: 17px;
  margin: 0;
  padding: 0;
}
.menu-popover ion-label {
  padding: 0;
  margin: 0;
  color: var(--ion-color-secondary);
  font-size: 12px;
}
.menu-popover ion-item {
  padding: 0 20px;
  margin: 0;
  line-height: 40px;
}
.menu-popover ion-item::part(native) {
  min-height: 30px;
  font-size: 12px;
}
.menu-popover ion-item:last-child {
  --border-width: 0 0 0 0 !important;
  --inner-border-width: 0 0 0 0 !important;
}

.comments-box {
  background-color: var(--planeed-color-white);
  padding: 0;
}
.comments-box ion-item {
  --ion-background-color: var(--planeed-color-white);
}
.comments-box ion-icon {
  margin-top: 4px;
  font-size: 17px;
  margin-left: 5px;
}

.thumb_img {
  border-radius: 50%;
  width: 30px !important;
  height: 30px !important;
  margin-right: 10px;
  object-fit: cover;
}

.avatar-box {
  height: 100%;
  padding-top: 16px;
}

.comment-reply {
  margin-left: 20px !important;
}
.comment-reply div, .comment-reply div {
  padding-right: 0;
}

.comment-buttons {
  color: var(--ion-color-medium);
  font-size: 12px;
  display: grid;
  grid-column: 3;
  grid-auto-flow: column;
  gap: 4px;
  margin-top: 5px;
  padding: 0;
}
.comment-buttons ion-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  display: inline-block;
  margin-top: 3px;
}

.comment-buttons span {
  margin: 0 12px 0 0;
  min-width: 60px;
}
@media only screen and (min-width: 460px) {
  .comment-buttons span {
    min-width: 110px;
  }
}

.comment-buttons-reply {
  color: var(--ion-color-medium);
  font-size: 12px;
  display: grid;
  grid-column: 3;
  grid-auto-flow: column;
  gap: 4px;
  margin-top: 5px;
  padding: 0;
}
.comment-buttons-reply ion-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  display: inline-block;
  margin-top: 3px;
}

.comment-buttons-reply span {
  margin: 0 12px 0 0;
  min-width: 60px;
}
@media only screen and (min-width: 460px) {
  .comment-buttons-reply span {
    min-width: 110px;
  }
}

.comment-border-link {
  display: block;
  position: absolute;
  top: 50px;
  left: 0;
  width: 12px;
  height: calc(100% - 50px);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  background-color: rgba(0, 0, 0, 0.1);
  background-clip: padding-box;
}

.link {
  color: var(--ion-color-warning);
  font-weight: bold;
  text-transform: capitalize;
  cursor: pointer;
}

.menuButtons {
  position: absolute;
  margin-top: -25px;
  right: 17px;
  left: auto;
}

.trippleDotMenuButton {
  font-size: 17px;
}

ion-popover {
  --backdrop-opacity: 0;
  --box-shadow: none;
  --background: transparent;
}
ion-popover ion-item {
  --ion-background-color: var(--planeed-color-white);
  color: #000;
}

.comment-datetime {
  color: var(--ion-color-medium-shade);
  font-style: normal;
  font-size: 12px;
}

h2 {
  cursor: pointer;
  font-size: 14px;
  line-height: 21px;
  color: #363636;
  font-weight: 500;
}

.comment-text {
  color: #363636;
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
}

.like-container {
  display: flex;
}

.like-icon {
  margin-right: 5px;
}

.like-text {
  font-weight: 300;
}

.answer-or-comment {
  text-align: right;
}

.ion-text-wrap {
  width: 88%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
